"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const bnscodec_1 = require("./bnscodec");
const bnsconnection_1 = require("./bnsconnection");
/**
 * A helper to connect to a bns-based chain at a given url
 */
function createBnsConnector(url, expectedChainId) {
    return {
        establishConnection: () => __awaiter(this, void 0, void 0, function* () { return bnsconnection_1.BnsConnection.establish(url); }),
        codec: bnscodec_1.bnsCodec,
        expectedChainId: expectedChainId,
    };
}
exports.createBnsConnector = createBnsConnector;
//# sourceMappingURL=bnsconnector.js.map